import React from 'react';
import { Link } from 'gatsby';
import Scrollspy from 'src/interface/vendors/scrollspy-wrapper';
import { AnchorLink } from 'src/interface/basics/links';
import { ButtonWrapper } from 'src/interface/basics/buttons';
import { FalIcon } from 'src/interface/vendors/fa-wrapper';

const Subnav = ({ active, className = '', children }) => (
	<nav className={`subnav ${active ? 'fixed s-bottom-2' : 'absolute'} ${className}`}>
		{children}
	</nav>
)

const SubnavItem = ({ className = '', children }) => (
	<li className={`subnav-item ${className}`}>{children}</li>
)

const SubnavBtn = ({ taskRunning, onClick, className = '', children }) => (
  <ButtonWrapper onClick={onClick} className={`subnav-btn ${className}`}>
    {children}
  </ButtonWrapper>
)

const SubnavLink = ({ to, className = '', children }) => (
	<Link to={to} className={`link subnav-link ${className}`}>
		{children}
	</Link>
)

const SubnavScrollspy = ({ to, item, onUpdate, className = '', children }) => (
	<Scrollspy componentTag='div' items={[item]} onUpdate={onUpdate} currentClassName='active'>
		<AnchorLink to={to} className={`btn subnav-link ${className}`}>
			{children}
		</AnchorLink>
	</Scrollspy>
)

export { Subnav, SubnavItem, SubnavBtn, SubnavLink, SubnavScrollspy }

// Docs
// https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-link/
// https://getbootstrap.com/docs/5.0/components/navs-tabs/
